import { useProductTitle } from "./product-title.hook";

export const ProductTitle = ({ status }: { status: string }) => {
  const { t, product } = useProductTitle();

  const Status = (
    <div className="text-uppercase bg-7c2d35 c-ffffff font-12-bold d-inline-block px-2 mb-4 mt-md-5">
      {t(status)}
    </div>
  );

  const Title = (
    <div className="mb-5 product-title-dynamic-size-title">
      {product?.prodottoDesc}
    </div>
  );

  const Subtitle = (
    <div className="c-646464 product-title-dynamic-size-subtitle">
      {product?.prodottoSottotitolo}
    </div>
  );

  return (
    <div>
      {Status}
      {Title}
      {Subtitle}
    </div>
  );
};
